import React from 'react';

const AnalyticsDashboard = ({ users }) => {
  // Calculate total logins
  const totalLogins = users.reduce((sum, user) => sum + (user.loginCount || 0), 0);

  // Calculate most viewed boat
  let mostViewedBoat = null;
  let maxViews = 0;

  users.forEach(user => {
    user.boats.forEach(boat => {
      if (boat.viewCount > maxViews) {
        maxViews = boat.viewCount;
        mostViewedBoat = { name: boat.name, owner: user.username, views: boat.viewCount };
      }
    });
  });

  // Sort users by login count for the table
  const sortedUsersByLogin = [...users].sort((a, b) => (b.loginCount || 0) - (a.loginCount || 0));


  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Analíticas de la Plataforma</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h4 className="font-semibold text-gray-800 mb-2">Total de Inicios de Sesión</h4>
          <p className="text-2xl font-bold text-blue-600">{totalLogins}</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm">
          <h4 className="font-semibold text-gray-800 mb-2">Embarcación Más Vista</h4>
          {mostViewedBoat ? (
            <p className="text-lg text-gray-700">
              "{mostViewedBoat.name}" (Propietario: {mostViewedBoat.owner}) con {mostViewedBoat.views} vistas.
            </p>
          ) : (
            <p className="text-gray-600">No hay datos de vistas disponibles.</p>
          )}
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h4 className="font-semibold text-gray-800 mb-2">Actividad de Usuarios (Inicios de Sesión)</h4>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuario</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rol</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Inicios de Sesión</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {sortedUsersByLogin.map(user => (
                <tr key={user.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{user.username}</td>
                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${user.role === 'admin' ? 'bg-purple-100 text-purple-800' : user.role === 'masteradmin' ? 'bg-red-100 text-red-800' : user.role === 'guest' ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-800'}`}>
                          {user.role === 'admin' ? 'Administrador' : user.role === 'masteradmin' ? 'Admin Maestro' : user.role === 'guest' ? 'Invitado' : 'Usuario'}
                        </span>
                      </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500">{user.loginCount || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDashboard;